import {
  BRAUN_BANNER_CLICKED,
  CUSTOMER_RATINGS_CLICKED,
  SKINTIST_BANNER_CLICKED,
} from 'shared/experiments/browser/hideCustomerRatings/consts'
import {
  EXPERIMENT_VARIATION,
  REPLACE_CUSTOMER_RATINGS_COM,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'

const hideCustomerRatingsEventTracking = async () => {
  const { isEnabled, variant } =
    getExperimentOnClient(REPLACE_CUSTOMER_RATINGS_COM) || {}

  if (!isEnabled) {
    return
  }
  await activateExperiment(REPLACE_CUSTOMER_RATINGS_COM)

  if (variant === EXPERIMENT_VARIATION.DEFAULT) {
    const customerRatingsContainer = document.querySelector<HTMLElement>(
      '.o-CmsContent__ComponentLegacyRatings'
    )
    customerRatingsContainer?.addEventListener('click', event => {
      const element = <HTMLElement>event.target
      if (
        element.closest('[name="product-rating-image-link"]') ||
        element.closest('[name="product-rating-heading-link"]') ||
        element.closest('.o-ProductRatingCard__column-desktop__to-rating__link')
      ) {
        trackEvent(CUSTOMER_RATINGS_CLICKED)
      }
    })
  }
  if (variant === EXPERIMENT_VARIATION.V1) {
    const bannerContainer =
      document.querySelector<HTMLElement>('.e-BrandBanners')

    bannerContainer?.addEventListener('click', event => {
      const element = <HTMLElement>event.target

      if (element.closest('.e-braunBanner')) {
        trackEvent(BRAUN_BANNER_CLICKED)
      } else if (element.closest('.e-skintistBanner')) {
        trackEvent(SKINTIST_BANNER_CLICKED)
      }
    })
  }
}
export default hideCustomerRatingsEventTracking
